module.exports = __webpack_public_path__ + "img/aziende-jobmule.78796037.png";